import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    // Absolute layer over the feed; own scroll flows inside the tool content.
    layer: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    hidden: {
      display: 'none',
    },
  },
  { name: 'HomeToolLayer' }
);

export default useStyles;
